var _circle, _circle2, _circle3, _circle4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfidentalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    fill: "#ECF5F8",
    stroke: "#4097AD",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.5,
    fill: "#F8D7C8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6.5,
    fill: "#F1AF90"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5.5,
    fill: "#E87A46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6062 12.2387L11.0906 11.7343C11.0156 11.6622 10.9266 11.6262 10.8236 11.6262C10.7204 11.6262 10.6312 11.6622 10.5562 11.7343C10.4812 11.8063 10.4422 11.8918 10.4392 11.9908C10.436 12.09 10.4719 12.1756 10.5469 12.2477L11.3438 13.0134C11.4188 13.0854 11.5062 13.1214 11.6062 13.1214C11.7062 13.1214 11.7937 13.0854 11.8687 13.0134L13.4625 11.4821C13.5375 11.41 13.575 11.3244 13.575 11.2252C13.575 11.1262 13.5375 11.0407 13.4625 10.9686C13.3875 10.8966 13.2985 10.8605 13.1955 10.8605C13.0922 10.8605 13.0031 10.8966 12.9281 10.9686L11.6062 12.2387ZM12 15.5625H11.9062C11.875 15.5625 11.8469 15.5565 11.8219 15.5445C11.0031 15.2983 10.3281 14.8103 9.79688 14.0806C9.26562 13.3511 9 12.545 9 11.6622V9.95978C9 9.80966 9.04537 9.67454 9.13612 9.55444C9.22662 9.43434 9.34375 9.34727 9.4875 9.29322L11.7375 8.48254C11.825 8.45251 11.9125 8.4375 12 8.4375C12.0875 8.4375 12.175 8.45251 12.2625 8.48254L14.5125 9.29322C14.6563 9.34727 14.7735 9.43434 14.8643 9.55444C14.9548 9.67454 15 9.80966 15 9.95978V11.6622C15 12.545 14.7344 13.3511 14.2031 14.0806C13.6719 14.8103 12.9969 15.2983 12.1781 15.5445C12.1469 15.5565 12.0875 15.5625 12 15.5625Z",
    fill: "#ECF5F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidentalIcon);
export default __webpack_public_path__ + "static/media/ConfidentalIcon.798402aa015d7b4a32f96dd2b4a0dd42.svg";
export { ForwardRef as ReactComponent };